import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
const toneClass = {
    neutral: 'bg-muted text-muted-foreground',
    success: 'bg-success-muted text-success',
    warning: 'bg-warning-muted text-warning',
    danger: 'bg-danger-muted text-danger',
    info: 'bg-info-muted text-info'
};
const sizeClass = {
    sm: 'size-[var(--icon-tile-sm)] rounded-sm [&_svg]:size-3',
    md: 'size-[var(--icon-tile-md)] rounded-[var(--radius-control)] [&_svg]:size-[var(--icon-size-ui)]',
    lg: 'size-[var(--icon-tile-lg)] rounded-md [&_svg]:size-4'
};
/** Semantic icon container used in actions, search results, and summaries. */ export const SpecraIconTile = /*#__PURE__*/ React.forwardRef(({ className, label, size = 'md', tone = 'neutral', ...props }, ref)=>/*#__PURE__*/ _jsx("span", {
        "aria-hidden": label ? undefined : true,
        "aria-label": label,
        className: cn('inline-flex shrink-0 items-center justify-center', toneClass[tone], sizeClass[size], className),
        ref: ref,
        role: "img",
        ...props
    }));
SpecraIconTile.displayName = 'SpecraIconTile';
